const r = require.context('../components', false, /\.vue$/);

export default app => {
  r.keys().forEach(fileName => {
    app.component('app-' + fileName.slice(2, -4), r(fileName).default);
  });
};
